import { render } from "./editSwiper.vue?vue&type=template&id=4556532a&scoped=true"
import script from "./editSwiper.vue?vue&type=script&lang=js"
export * from "./editSwiper.vue?vue&type=script&lang=js"

import "./editSwiper.vue?vue&type=style&index=0&id=4556532a&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4556532a"]])

export default __exports__